<template>
  <div class="card">
    <div class="card-body">
      <b-row>
        <b-col xl="3" lg="3" md="6" sm="12" class="pt-1">
          <b-form-select class="form-select mb-3" v-model="fulfilment" :options="fulfillmentOptions"
                         @input="handleFulfilment"/>
        </b-col>
        <b-col xl="3" lg="3" md="6" sm="12" class="pt-1">
          <market-place-component @input="handleMarketplace"/>
        </b-col>
        <b-col xl="3" lg="3" md="6" sm="12" class="pt-1">
          <date-picker v-model="dateRange"
                       range
                       append-to-body
                       :lang="$i18n.locale"
                       confirm
                       valueType="timestamp"
                       :placeholder="$t('pages.order.date_range')"
                       @change="handleDate"
                       format="DD/MM/YYYY"></date-picker>
        </b-col>
      </b-row>
    </div>
  </div>

</template>

<script>
import DatePicker from "vue2-datepicker";
import MarketPlaceComponent from "../../../components/widgets/MarketPlaceComponent";

export default {
  name: "OrderFilter",
  components: {MarketPlaceComponent, DatePicker},
  data() {
    return {
      fulfilment: null,
      dateRange: null,
      fulfillmentOptions: [
        {
          text: this.$t('pages.order.fulfillment_chips.title'),
          value: null
        },
        {
          text: this.$t('pages.order.fulfillment_chips.mfn'),
          value: 'mfn'
        },
        {
          text: this.$t('pages.order.fulfillment_chips.mfn'),
          value: 'afn'
        }
      ]
    }
  },
  methods: {
    handleMarketplace(e) {
      this.$emit('marketplace', e)
    },
    handleDate(e) {
      this.$emit('date', e)
    },
    handleFulfilment(e) {
      this.$emit('fulfilment', e)
    }
  }
}
</script>

<style scoped>

</style>